export const GET_LIST_CATEGORIES = '/category/list';
export const GET_ALL_CATEGORIES = '/category/getAll';
export const GET_CATEGORY_INFO = '/category/getById';
export const CREATE_CATEGORY = '/category/create';
export const UPDATE_CATEGORY = '/category/update';
export const DELETE_CATEGORY = '/category/delete';
